import * as React from "react"
import { connect } from "react-redux"
import trans from "trans"

import {
    GridCell,
    FieldLabel,
    Icon,
} from "@bdfx/mergado-ui-kit"

import {StyledSliderDiv} from "./filters";
import { Slider } from "@mui/material";
import { selectFormValues, updateInputValue } from "app/reducers/form";
import { FiltersFormType } from "products/types/filtertypes";
import { StyledInputGroupFilter } from "shape-edit/forms/fields";

interface Props {
    setIsDirty: Function
    userId: number
    filtersForm: FiltersFormType
    updateInputValue: typeof updateInputValue
}

class WatermarksFilters extends React.Component<Props> {
    constructor(props: Props) {
        super(props)
    }

    render() {
        const { userId, filtersForm } = this.props

        const watermarkUserSetObjectsOptions = [
            {
                value: '0',
                label: trans('without_objects'),
            },
            {
                value: '1',
                label: trans('with_objects'),
            },
        ]

        const filterStatuses = filtersForm.watermark?.status && Array.isArray(filtersForm.watermark.status) ? filtersForm.watermark.status : ['NOT_OK']    //multiselect!!!
        const filterWithWatermarks = filterStatuses.includes('NOT_OK')  //with or without, watermarks, default filter products with watermarks

        const isFromNull = typeof filtersForm.watermark?.confidence?.from === 'undefined' || filtersForm.watermark.confidence.from === null
        const isToNull = typeof filtersForm.watermark?.confidence?.to === 'undefined' || filtersForm.watermark.confidence.to === null

        const filterFrom = filterWithWatermarks ? (isFromNull ? 50 : parseInt(`${filtersForm.watermark.confidence.from}`)) : 0
        const filterTo = !filterWithWatermarks ? (isToNull ? 50 : parseInt(`${filtersForm.watermark.confidence.to}`)) : 100

        return (
            <React.Fragment>
                <GridCell className={!isFromNull || !isToNull ? 'active-filter' : ''}>
                    <div style={{ display: 'flex' }}>
                        <FieldLabel><Icon type={'paw'} text={trans('filter_probability')} /></FieldLabel>
                        {(!isFromNull || !isToNull) &&
                            <span className='clickable' onClick={() => this.props.updateInputValue('filtersForm', 'watermark.confidence', null)}>
                                <Icon type={'close-light'} color={'#3a3a3a'} />
                            </span>
                        }
                    </div>

                    <StyledSliderDiv>
                        <Slider
                            value={filterWithWatermarks ? filterFrom : filterTo}
                            onChange={(event: Event, value: number[]) => {
                                if (filterWithWatermarks) {
                                    this.props.updateInputValue('filtersForm', 'watermark', {
                                        ...filtersForm.watermark,
                                        confidence: {
                                            from: value,
                                            to: 100,
                                        },
                                    })
                                } else {
                                    this.props.updateInputValue('filtersForm', 'watermark', {
                                        ...filtersForm.watermark,
                                        confidence: {
                                            from: 0,
                                            to: value,
                                        },
                                    })
                                }
                            }}
                            color={isFromNull && isToNull ? 'secondary' : 'primary'}
                            track={filterWithWatermarks ? "inverted" : "normal"}
                            step={1}
                            min={0}
                            max={100}
                            marks={[{ value: 0, label: '0%' }, { value: 25 }, { value: 50, label: '50%' }, { value: 75 }, { value: 100, label: '100%' }]}
                            valueLabelDisplay="auto"
                            getAriaLabel={() => `${trans('filter_probability')} [%]`}
                            getAriaValueText={(value) => `${value}%`}
                            valueLabelFormat={(value) => `${value}%`}
                        />
                    </StyledSliderDiv>
                </GridCell>

                <GridCell className={filtersForm.watermark.user_set !== null ? 'active-filter' : ''}>
                    <StyledInputGroupFilter
                        formName='filtersForm.watermark.user_set'
                        singleChoice={true}
                        onChange={() => this.props.setIsDirty(true)}
                        transString={'filter_user_set_watermark'}
                        iconType={'paw'}
                        showClear={filtersForm.watermark.user_set}
                        items={[
                            { value: '0', label: trans('has_no_watermark') },
                            { value: '1', label: trans('has_watermark'), },
                        ]}
                        onClear={() => {
                            this.props.updateInputValue('filtersForm', 'watermark.user_set', null)
                            this.props.setIsDirty(true)
                        }}
                    />
                </GridCell>


                <GridCell className={filtersForm.watermark.user_set_objects ? 'active-filter' : ''}>
                    <StyledInputGroupFilter
                        formName='filtersForm.watermark.user_set_objects'
                        singleChoice={true}
                        onChange={() => this.props.setIsDirty(true)}
                        transString={'with_or_without_objects'}
                        iconType={'paint-brush'}
                        showClear={filtersForm.watermark.user_set_objects}
                        items={watermarkUserSetObjectsOptions}
                        onClear={() => {
                            this.props.updateInputValue('filtersForm', 'watermark.user_set_objects', null)
                            this.props.setIsDirty(true)
                        }}
                    />

                </GridCell>
            </React.Fragment>
        )
    }
}

function mapStateToProps(state) {
    return {
        filtersForm: selectFormValues(state, 'filtersForm'),
    }
}

export default connect(mapStateToProps, {
    updateInputValue,
})(WatermarksFilters)
